import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import SolutionsPage from '@/pages/solutions/page';
import SolutionDetailPage from '@/pages/solutions/detail/page';
import ToolsPage from '@/pages/tools/page';
import ToolDetailPage from '@/pages/tools/detail/page';
import MemberPage from '@/pages/member/page';
import AdminPage from '@/pages/admin/page';
import LoginPage from '@/pages/login/page';
import AboutPage from '@/pages/about/page';
import NotFound from '@/pages/NotFound';
import ProtectedRoute from '@/components/feature/ProtectedRoute';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/solutions', element: <SolutionsPage /> },
  { path: '/solutions/:id', element: <SolutionDetailPage /> },
  { path: '/tools', element: <ToolsPage /> },
  { path: '/tools/:id', element: <ToolDetailPage /> },
  {
    path: '/member',
    element: (
      <ProtectedRoute>
        <MemberPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute requireAdmin>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  { path: '/login', element: <LoginPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
